// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3f2Lp","title":"BackImages_title__1AVo5","images":"BackImages_images__lQ8DZ"};